/**
 * Wraps a rate limiter around a function that ensures the function is invoked max once per `intervalInMs`.
 */
export function withRateLimit(fn, intervalInMs) {
    let lastInvocationTimestamp = 0;
    return async () => {
        const now = Date.now();
        if (now - lastInvocationTimestamp >= intervalInMs) {
            lastInvocationTimestamp = now;
            await fn();
        }
    };
}
